import { Link } from "react-router-dom";
import { Users } from "lucide-react";

export const TaggedPeople = ({ people, max = 3, testid = "tagged-people", onRemoveMe, meId }) => {
  if (!people?.length) return null;
  const shown = people.slice(0, max);
  const extra = people.length - shown.length;
  const isTagged = meId && people.some((p) => p.id === meId);
  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[13px] text-[#8A8D91]">
      <Users size={13} className="shrink-0" />
      <span>with</span>
      {shown.map((p, i) => (
        <span key={p.id || p.username}>
          <Link to={`/u/${p.username}`} onClick={(e) => e.stopPropagation()} data-testid={`${testid}-link-${p.username}`} className="text-white font-semibold hover:underline">@{p.username}</Link>
          {i < shown.length - 1 || extra > 0 ? "," : ""}
        </span>
      ))}
      {extra > 0 && <span data-testid={`${testid}-more`}>+{extra} more</span>}
      {isTagged && onRemoveMe && (
        <button type="button" data-testid={`${testid}-remove-me`} onClick={onRemoveMe} className="ml-1 text-xs text-[#8A8D91] hover:text-[#FF4D6D] underline underline-offset-2 transition-colors">Remove me</button>
      )}
    </div>
  );
};
